import * as React from 'react';
import { currentUrl, getLocalStorageItem, setLocalStorageItem, useCurrentPage, useStaticData } from '@avensia/excite';
import type { ExperienceConfiguration } from '@ninetailed/experience.js';
import type { NinetailedPlugin } from '@ninetailed/experience.js-plugin-analytics';
import type { ExposedAudienceDefinition } from '@ninetailed/experience.js-preview-bridge';
import { NinetailedPreviewPlugin } from '@ninetailed/experience.js-plugin-preview';
import { NINETAILED_PREVIEW_KEY } from './utils';

interface NtCurrentPageProps {
  audiences: ExposedAudienceDefinition[];
  experiences: ExperienceConfiguration[];
}

function pageHasNinetailedExperience(currentPage: any): currentPage is NtCurrentPageProps {
  return Boolean((currentPage as NtCurrentPageProps)?.audiences);
}

function useNinetailedPreview(): NtCurrentPageProps | undefined {
  const currentPage = useCurrentPage();

  // TODO: Add back static data when fix the backend
  const dynamicDataExperiences: any = undefined;

  const experiences = React.useMemo(() => {
    return dynamicDataExperiences?.experiences || [];
  }, [dynamicDataExperiences]);

  const audiences = React.useMemo(() => {
    return dynamicDataExperiences?.audiences || [];
  }, [dynamicDataExperiences]);

  const preview = currentUrl().searchParams.has(NINETAILED_PREVIEW_KEY);
  if (preview && __BROWSER__) {
    const val = currentUrl().searchParams.get(NINETAILED_PREVIEW_KEY) === 'off' ? false : true;
    setLocalStorageItem(NINETAILED_PREVIEW_KEY, val);
  }

  if (!__BROWSER__ || !getLocalStorageItem(NINETAILED_PREVIEW_KEY)) {
    return undefined;
  }

  if (pageHasNinetailedExperience(currentPage)) {
    return {
      audiences: audiences.concat(currentPage.audiences),
      experiences: experiences.concat(currentPage.experiences),
    };
  }

  return { audiences: [], experiences: experiences };
}

export function useGetPreviewPlugin(): NinetailedPlugin | undefined {
  const previewOptions = useNinetailedPreview();
  return previewOptions ? new NinetailedPreviewPlugin(previewOptions as NtCurrentPageProps) : undefined;
}
